import get from 'lodash/get';
import { createSelector } from '@reduxjs/toolkit';
import { ROLES } from 'utils/constants';
import { getGlobalDepartments } from 'utils/personnelHelper';
// Actions
export const SET_USER = 'SET_USER';
export const ROUTE_USER = 'ROUTE_USER';
// Reducer
export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case SET_USER:
      return {
        ...state,
        ...action.user,
        location: action.user.operational.location &&
          action.user.operational.location.point && {
            lat: action.user.operational.location.point.latitude,
            lng: action.user.operational.location.point.longitude,
          },
      };
    // do reducer stuff
    default:
      return state;
  }
}

// Action Creators
export function setUserInfo(user) {
  return { type: SET_USER, user };
}
export function routeUser(user) {
  return {
    type: ROUTE_USER,
    user,
  };
}

// Selectors
export const getUserImage = state => get(state, 'user.general.photoUrl', '');
export const getGeneralInfo = state => get(state, 'user.general', {});
export const getUserInfo = state => get(state, 'user', {});
export const getFullUserName = state => {
  const general = getGeneralInfo(state);
  const { firstName, lastName } = general;

  return `${firstName} ${lastName}`;
};

export const getRegionId = state => get(state, 'user.general.regionId');
export const getSecurityId = state =>
  get(state, 'user.general.securityCompanyId');
export const getSecurityCompanyName = state =>
  get(state, 'user.general.securityCompanyName');
export const getBusinessClientId = state =>
  get(state, 'user.general.businessClientId');
export const getUserRoles = state => get(state, 'user.general.roles');
export const getUserLocation = state => get(state, 'user.location');
export const getUserId = state => get(state, 'user.general.id');
export const getUserName = state => get(state, 'user.general.name');
export const getUserSelectedLanguage = state => {
  const lang = get(state, 'user.details.settings.i18n', 'en');
  if (lang !== '') {
    return lang.toLowerCase();
  } else return 'en';
};

// state selectors
const roleSelector = state => state.user.general.roles;
const departmentRecordsSelector = state => state.globalList.departments.record;
const assignedDepartmentSelector = state => state.user.general.departmentIds;

// selector to get assigned departments for a manager or account holder
export const getUserAssignedDepartmentList = createSelector(
  roleSelector,
  departmentRecordsSelector,
  assignedDepartmentSelector,
  (roles, records = {}, assignedDepartmentsIds = []) => {
    // convert department Record object to array of name and id
    const departmentLists = getGlobalDepartments(records);
    if (roles.includes(ROLES.SECURITY_COMPANY_MANAGER.id)) {
      // If the logged in user is an account holder, the return everything in the global list
      return departmentLists;
    } else if (
      roles.includes(ROLES.MANAGER.id) ||
      roles.includes(ROLES.SUPERVISOR.id)
    ) {
      // only return the department the manager/supervisor is assigned to
      return departmentLists.filter(f =>
        assignedDepartmentsIds?.includes(f.id),
      );
    }
    return [];
  },
);
